import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * @description:此文件用于放置消息通知页面弹窗
 * **/

export var noticeRouter = [{
  path: '/require-approve',
  component: function component() {
    return import('@/views/pcDialog/requireApprove/index.vue');
  },
  meta: {
    title: '需求审批',
    keepAlive: false
  }
}, {
  path: '/biz-allocation',
  component: function component() {
    return import('@/views/pcDialog/bizAllocation/index.vue');
  },
  meta: {
    title: '转介绍审批',
    keepAlive: false
  }
}, {
  path: '/project-pull-group',
  component: function component() {
    return import('@/views/h5/project-pull-group/index.vue');
  },
  meta: {
    title: '项目一键拉群',
    keepAlive: true
  }
}, {
  path: '/assist-list-approve',
  component: function component() {
    return import('@/views/pcDialog/assistListApprove/assistListApprove.vue');
  },
  meta: {
    title: '企微协单审批',
    keepAlive: true
  }
}, {
  path: '/require-update-approve',
  component: function component() {
    return import('@/views/pcDialog/requireUpdateApprove/index.vue');
  },
  meta: {
    title: '需求类型变更审批',
    keepAlive: true
  }
}, {
  path: '/warning-notice',
  component: function component() {
    return import('@/views/pcDialog/warningNotice/index.vue');
  },
  meta: {
    title: '预警明细',
    keepAlive: true
  }
}, {
  path: '/look-wechat-approve',
  component: function component() {
    return import('@/views/pcDialog/lookWechatApprove/index.vue');
  },
  meta: {
    title: '电话号码查看审批',
    keepAlive: true
  }
}, {
  path: '/schdule-task',
  component: function component() {
    return import('@/views/pcDialog/schduleTask/index.vue');
  },
  meta: {
    title: '待办任务详情',
    keepAlive: true
  }
}, {
  path: '/scan-code-group',
  component: function component() {
    return import('@/views/h5/scan-code-group/index.vue');
  },
  meta: {
    title: '扫码加群',
    keepAlive: true
  }
}, {
  path: '/approve-invite',
  name: 'approveInvite',
  component: function component() {
    return import('@/views/pcDialog/checkInvite/page/index');
  },
  meta: {
    title: '邀约面谈新审批',
    keepAlive: false
  }
}, {
  path: '/chose-date',
  name: 'choseDate',
  component: function component() {
    return import('@/views/pcDialog/checkInvite/dialog/choseDateDialog');
  },
  meta: {
    title: '选择面谈时间',
    keepAlive: false
  }
}, {
  path: '/update-wechat-group',
  name: 'updateWechatGroup',
  component: function component() {
    return import('@/views/pcDialog/updateWechatGroup/index.vue');
  },
  meta: {
    title: '项目更新群成员',
    keepAlive: false
  }
}, {
  path: '/auto-remove-group',
  component: function component() {
    return import('@/views/pcDialog/autoRemoveGroup/index.vue');
  },
  meta: {
    title: '自动剔除群成员',
    keepAlive: true
  }
}];